import { TRESPONSE_AI_ANALYTICS_QUESTION } from '@monorepo/types';
import { TChatUiModel } from '@monorepo/ui/chat-ui';
import { Action } from '@ngrx/store';
import { TAiAnalyticsActionType } from './ai-analytics.models';

export class SetAiAnalyticsChatUiModel implements Action {
  readonly type = TAiAnalyticsActionType.SetAiAnalyticsChatUiModel;
  constructor(public payload: TChatUiModel<TRESPONSE_AI_ANALYTICS_QUESTION>) {}
}
export class GetAiAnalyticsChatUiModel implements Action {
  readonly type = TAiAnalyticsActionType.GetAiAnalyticsChatUiModel;
  constructor() {}
}
export class SetAiAnalyticsLastSeparatorText implements Action {
  readonly type = TAiAnalyticsActionType.SetAiAnalyticsLastSeparatorText;
  constructor(public payload: string | null) {}
}

export type TAiAnalyticsActions =
  | GetAiAnalyticsChatUiModel
  | SetAiAnalyticsChatUiModel
  | SetAiAnalyticsLastSeparatorText;
